import React from 'react';
import { FieldArray, Field, ErrorMessage } from 'formik';
import TextError from '../TextError';
import plusIcon from '../../../assets/images/plus-blue.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

const CustomFieldArray = (props) => {
  const { label, name, className, style, labelClassname, id, values, ...rest } =
    props;

  return (
    <>
      <FieldArray id={id} name={name}>
        {(arrayHelpers) => {
          return (
            <>
              <div className="d-flex align-items-center">
                <label className={labelClassname} htmlFor={id}>
                  {label}
                  {rest.isRequired ? (
                    <span className="text-danger">*</span>
                  ) : null}
                </label>

                <FontAwesomeIcon
                  icon={faPlusCircle}
                  size={'2x'}
                  color={'#088fff'}
                  className="m-4"
                  onClick={() => arrayHelpers.push('')}
                />
              </div>
              {values?.map((value, index) => {
                return (
                  <div className="d-flex align-items-center" key={index}>
                    <Field
                      type="text"
                      id={`${name}.${index}`}
                      name={`${name}.${index}`}
                      value={value}
                      className={className}
                    />
                    <FontAwesomeIcon
                      icon={faMinusCircle}
                      size={'2x'}
                      color={'#088fff'}
                      className="m-4"
                      onClick={() => arrayHelpers.remove(index, '')}
                    />
                  </div>
                );
              })}
            </>
          );
        }}
      </FieldArray>
      <ErrorMessage component={TextError} name={name} />
    </>
  );
};

export default CustomFieldArray;
